export default __webpack_public_path__ + "static/media/profile-picture-4.97bdda51.jpg";